import "@/app.css"
import Footer from "@/components/Home/Footer";
import { Link, useNavigate } from "react-router-dom";
import logo from "@/assets/talentick.ai.webp";
import { useState } from "react";
export default function PrivacyPolicy() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate()
    const navigation = () => {
        setMobileMenuOpen(false)
        navigate("/")
    }
    return (
        <div className="min-h-screen ">
            <header className="fixed top-5 w-full md:flex justify-center z-50">

                <div className="w-[90vw] rounded-full py-3 px-6 shadow-sm  border border-gray-200 mx-auto flex justify-between items-center bg-white ">


                    {/* Logo */}
                    <div className="flex items-center">
                        <img src={logo} alt="Bluetick Logo" className="w-32 cursor-pointer" />
                    </div>

                    {/* Desktop Nav */}
                    <nav className="hidden md:flex items-center space-x-10 ml-10">
                        <a onClick={navigation} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Home</a>
                        <a onClick={navigation} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Features</a>
                        <a onClick={navigation} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Pricing</a>
                    </nav>

                    {/* Auth Buttons */}
                    <div className="hidden md:flex items-center gap-4">
                        <Link to="/login" className="px-4 py-2 rounded-full border border-[#7EB08A] hover:scale-110 transition-all">Log in</Link>
                        <Link to="/register" className="bg-black text-white px-4 py-2 rounded-full border border-[#7EB08A] hover:scale-110 transition-all">Get Started</Link>
                    </div>

                    {/* Mobile Hamburger */}
                    <div className="md:hidden">
                        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="md:hidden flex flex-col items-center bg-white shadow px-4 py-4 space-y-4 mx-2 mt-2 rounded-2xl">
                        <a onClick={navigation} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Home</a>
                        <a onClick={navigation} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Features</a>
                        <a onClick={navigation} className="text-gray-700 hover:text-[#7EB08A] cursor-pointer">Pricing</a>
                        <Link to="/login" className="text-[#7EB08A] border px-4 py-2 rounded-full border-[#7EB08A]">Log in</Link>
                        <Link to="/register" className="bg-black text-white px-4 py-2 rounded-full">Get Started</Link>
                    </div>
                )}
            </header>
            {/* Header Section */}
            <div className="w-full pt-16 pb-20  policy-banner h-[350px] flex justify-center items-center">

                <div className="container mx-auto px-6  ">
                    <h1 className="text-5xl font-bold text-center text-gray-900">Privacy Policy</h1>
                </div>
            </div>

            {/* Main Content */}
            <div className="container mx-auto px-6 py-10 max-w-5xl  text-justify">
                {/* Note Section */}
                <div className="bg-[#f1fdf8] p-6 rounded-lg mb-12">
                    <div className="flex items-center mb-3 bg-[#B3D5CC] rounded-full p-2 w-[80px]">
                        <div className="bg-black rounded-full w-4 h-4 flex items-center justify-center mr-2">

                        </div>
                        <span className="font-semibold">Note</span>
                    </div>
                    <p className="text-base ">
                        Talentick.ai ("we", "us", "our") is committed to protecting your privacy and ensuring the security
                        of your personal information. This Privacy Policy outlines how we collect, use, store, and protect
                        your data when you use our AI-powered recruitment platform. Please read this Privacy Policy
                        carefully. By using our services, you agree to the terms described below.
                    </p>
                </div>

                {/* Information We Collect */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Information We Collect</h2>
                    <p className="mb-4 ">We collect the following types of information:</p>
                    <ul className="list-disc space-y-3  pl-6">
                        <li className="">

                            <span><span className="font-semibold">Personal Information:</span> Name, email address, phone number, and other contact details provided during account registration or job application.</span>
                        </li>
                        <li className="">

                            <span><span className="font-semibold">Professional Information:</span> Resume/CV, employment history, education, skills, and assessment results.</span>
                        </li>
                        <li className="">

                            <span><span className="font-semibold">Usage Data:</span> Log data, IP address, browser type, device information, and interaction data with our platform.</span>
                        </li>
                        <li className="">

                            <span><span className="font-semibold">Assessment and Interview Data:</span> Responses to assessments, coding exercises, behavioral recordings, and performance summaries.</span>
                        </li>
                        <li className="">

                            <span><span className="font-semibold">Feedback and Analytics:</span> Candidate feedback, recruiter notes, and activity logs for analytics purposes.</span>
                        </li>
                    </ul>
                </section>

                {/* How We Use Your Information */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">How We Use Your Information</h2>
                    <p className="mb-4 ">We use your information to:</p>
                    <ul className="list-disc space-y-3  pl-6">
                        <li className="">

                            <span>Provide, maintain, and improve our recruitment platform and services.</span>
                        </li>
                        <li className="">

                            <span>Automate job description creation, candidate evaluation, and assessment generation.</span>
                        </li>
                        <li className="">

                            <span>Screen resumes and match candidates to job requirements using AI.</span>
                        </li>
                        <li className="">

                            <span>Generate and analyze candidate assessments and interview summaries.</span>
                        </li>
                        <li className="">

                            <span>Provide analytics and reporting to hiring teams to support data-driven hiring decisions.</span>
                        </li>
                        <li className="">

                            <span>Communicate with you regarding your account, job applications, or support requests.</span>
                        </li>
                        <li className="">

                            <span>Ensure compliance with legal obligations and platform security requirements.</span>
                        </li>
                    </ul>
                </section>

                {/* Sharing Your Information */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Sharing Your Information</h2>
                    <p className="mb-4 ">We may share your information with:</p>
                    <ul className="list-disc space-y-3  pl-6">
                        <li className="">

                            <span><span className="font-semibold">Employers and Hiring Teams:</span> To facilitate recruitment and candidate evaluation.</span>
                        </li>
                        <li className="">

                            <span><span className="font-semibold">Service Providers:</span> Third-party vendors who assist in operating our platform (e.g., cloud hosting, analytics) under strict confidentiality agreements.</span>
                        </li>
                        <li className="">

                            <span><span className="font-semibold">Legal Authorities:</span> When required by law or to protect our rights and users' safety.</span>
                        </li>
                    </ul>
                    <p className="mt-4 ">We do not sell or rent your personal data to third parties.</p>
                </section>

                {/* Data Retention */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Data Retention</h2>
                    <p className="">
                        We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy or as
                        required by law. You may request deletion of your data at any time by contacting us at <a href="mailto:support@talentick.ai" className="text-teal-600 hover:underline">support@talentick.ai</a>
                    </p>
                </section>

                {/* Data Security */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Data Security</h2>
                    <p className="">
                        We implement industry-standard security measures to protect your information, including data encryption,
                        access controls, and regular security assessments.
                    </p>
                </section>

                {/* International Data Transfers */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">International Data Transfers</h2>
                    <p className="">
                        Your information may be processed and stored in countries outside your own. We ensure appropriate
                        safeguards are in place for international transfers, in accordance with applicable data protection laws.
                    </p>
                </section>

                {/* Your Rights */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Your Rights</h2>
                    <p className="mb-4 ">Depending on your location, you may have the right to:</p>
                    <ul className="list-disc space-y-3  pl-6">
                        <li className="">

                            <span>Access, correct, or delete your personal information.</span>
                        </li>
                        <li className="">

                            <span>Object to or restrict certain processing activities.</span>
                        </li>
                        <li className="">

                            <span>Withdraw consent where processing is based on consent.</span>
                        </li>
                        <li className="">

                            <span>Request data portability.</span>
                        </li>
                    </ul>
                    <p className="mt-4 ">
                        To exercise your rights, please contact us at <a href="mailto:support@talentick.ai" className="text-teal-600 hover:underline">support@talentick.ai</a>
                    </p>
                </section>

                {/* Children's Privacy */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Children's Privacy</h2>
                    <p className="">
                        Our platform is not intended for individuals under the age of 16. We do not knowingly collect personal
                        information from children.
                    </p>
                </section>

                {/* Changes to This Policy */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Changes to This Policy</h2>
                    <p className="">
                        We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated
                        date. Please review this policy periodically.
                    </p>
                </section>

                {/* Contact Us */}
                <section className="mb-12">
                    <h2 className="text-3xl font-bold mb-6 text-gray-900">Contact Us</h2>
                    <p className="mb-4 ">
                        If you have questions or concerns about this Privacy Policy or your data, please contact us at:
                    </p>
                    <p className="">
                        • Email: <a href="mailto:support@talentick.ai" className="text-teal-600 hover:underline">support@talentick.ai</a>
                    </p>
                </section>
            </div>
            <Footer featScroll={navigation} pricingScroll={navigation} contactScroll={navigation} />
        </div>
    );
}